var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eliminar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.7 25.7",
    style: {
      enableBackground: "new 0 0 25.7 25.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{display:none;fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    className: "st0",
    d: "M3.2,6.4h19.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    className: "st0",
    d: "M20.3,6.4v15c0,1.2-1,2.1-2.1,2.1c0,0,0,0,0,0H7.5c-1.2,0-2.1-1-2.1-2.1c0,0,0,0,0,0v-15  M8.6,6.4V4.3c0-1.2,1-2.1,2.1-2.1c0,0,0,0,0,0H15c1.2,0,2.1,1,2.1,2.1c0,0,0,0,0,0v2.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    className: "st0",
    d: "M10.7,11.8v6.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    className: "st0",
    d: "M15,11.8v6.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    className: "st1",
    d: "M0,0h25.7v25.7H0V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashwhite);
export default __webpack_public_path__ + "static/media/trashwhite.1ee87cc12855ab8310ec107d41182d12.svg";
export { ForwardRef as ReactComponent };